<template>
  <div class="g-page">

    <!-- ═══════════════ HEADER ═══════════════ -->
    <div class="header-row">
      <h2 class="page-title">Ustalar</h2>
      <div class="header-actions">
        <div class="search-wrap">
          <svg class="s-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
          <input v-model="search" type="text" placeholder="Qidiruv..." class="search-input" />
        </div>
        <button class="btn-bulk" @click="openBulkUpdate" title="Barcha ustalarga bir xil sozlamalar">
          % Ommaviy
        </button>
        <button class="btn-bulk danger" @click="resetAllBalances" title="Pul balanslarini 0 qilish (kassaga tegmaydi)">
          0 Balans
        </button>
        <button class="btn-bulk warning" @click="resetAllBallBalances" title="Ball balanslarini 0 qilish (aksiya tugadi)">
          0 🎁 Ball
        </button>
        <button class="btn-add-header" @click="openUstaModal()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg>
          Yangi usta
        </button>
        <Top />
      </div>
    </div>

    <!-- ═══════════════ JADVAL ═══════════════ -->
    <div class="table-card">
      <div class="table-wrap">
        <table class="ctable">
          <thead>
            <tr>
              <th class="th-left">ISMI</th>
              <th>BONUS %</th>
              <th>BALL TIZIM</th>
              <th>MIJOZLAR</th>
              <th>TUSHUM</th>
              <th>ULUSH</th>
              <th>BALANS</th>
              <th>BALL</th>
              <th>AMALLAR</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="fetchLoading">
              <td colspan="9" class="empty-row">Yuklanmoqda...</td>
            </tr>
            <tr v-else-if="filteredData.length === 0">
              <td colspan="9" class="empty-row">Ma'lumot topilmadi</td>
            </tr>
            <tr
              v-for="row in filteredData"
              :key="row.id"
              class="trow"
              @click="openClients(row.id, row.name)"
            >
              <td class="td-left">
                <div class="m-name">{{ row.name }}</div>
                <div class="m-phone">{{ getStaff(row.id).phone_number }}</div>
              </td>
              <td class="td-gray">{{ getStaff(row.id).bonus || 0 }} %</td>
              <td class="td-gray" style="font-size:11px;">
                <template v-if="ballEnabled(row.id)">
                  <div><b>{{ fmtNumber(getStaff(row.id).ball_summa) }}</b> = {{ getStaff(row.id).ball_amount }} ball</div>
                  <div class="m-phone">progress: {{ fmtNumber(getStaff(row.id).ball_progress) }}</div>
                </template>
                <span v-else style="color:#cbd5e1">—</span>
              </td>
              <td class="td-dark td-bold">{{ getSummary(row.id).clients_count || 0 }}</td>
              <td class="td-blue td-bold">{{ fmtM(getSummary(row.id).total_revenue) }}</td>
              <td class="td-green td-bold">
                <div>{{ fmtM(computeShare(row.id)) }}</div>
                <div class="m-phone">{{ getStaff(row.id).bonus || 0 }}% × tushum</div>
              </td>
              <td :class="(row.kirim_summa - row.chiqim_summa) < 0 ? 'td-red td-bold' : 'td-dark td-bold'">
                {{ fmtM(row.kirim_summa - row.chiqim_summa) }}
              </td>
              <td class="td-bold" :class="(getBallReport(row.id).ball_balance || 0) > 0 ? 'td-green' : 'td-gray'">
                {{ getBallReport(row.id).ball_balance || 0 }} 🎁
              </td>
              <td @click.stop>
                <div class="act-btns">
                  <button class="act-btn view" title="Mijozlarini ko'rish" @click="openClients(row.id, row.name)">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  </button>
                  <button class="act-btn pay" title="To'lov qilish" @click="openPayModal(row)">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="1" y="4" width="22" height="16" rx="2"/><path d="M1 10h22"/></svg>
                  </button>
                  <button class="act-btn edit" title="Tahrirlash" @click="openUstaModal(row.id)">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  </button>
                  <button class="act-btn del" title="O'chirish" @click="deleteMaster(row.id)">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ═══════════════ USTA CRUD FORM ═══════════════ -->
    <UstaForm v-model="showForm" :edit-item="editItem" @saved="fetchData" />

    <!-- ═══════════════ MODAL 2: TO'LOV ═══════════════ -->
    <div v-if="payModal.show" class="overlay" @click.self="payModal.show = false">
      <div class="modal-box pay-modal-box">
        <div class="modal-head">
          <h3 class="modal-title">Ustaga to'lov</h3>
          <button class="close-btn" @click="payModal.show = false">&times;</button>
        </div>
        <div class="modal-body">

          <!-- Tanlangan usta -->
          <div class="master-badge">
            <div class="master-avatar">{{ payModal.masterName ? payModal.masterName[0] : 'U' }}</div>
            <div>
              <div class="master-badge-name">{{ payModal.masterName }}</div>
              <div class="master-badge-info">
                Oylik: <strong>{{ fmtM(payModal.masterSalary) }}</strong>
                &nbsp;·&nbsp;
                Balans: <strong :class="payModal.masterBalance < 0 ? 'c-red' : 'c-green'">{{ fmtM(payModal.masterBalance) }}</strong>
              </div>
            </div>
          </div>

          <!-- To'lov sababi yashirildi — default "Bonus" -->
          <!--
          <div class="field-group">
            <label class="flabel">To'lov sababi</label>
            <div class="reason-grid">
              <button
                v-for="r in payReasons"
                :key="r.value"
                class="reason-btn"
                :class="{ active: payModal.reason === r.value }"
                @click="selectReason(r.value)"
              >
                <span class="r-icon">{{ r.icon }}</span>
                {{ r.label }}
              </button>
            </div>
          </div>
          -->


          <!-- Summa -->
          <div class="field-group">
            <div class="label-row">
              <label class="flabel">Summa</label>
              <button
                v-if="quickAmount > 0"
                class="quick-btn"
                @click="fillQuick"
              >⚡ {{ shortM(quickAmount) }}</button>
            </div>
            <input
              type="text"
              :value="payModal.displayAmount"
              @input="handleAmount"
              class="finput finput-lg"
              placeholder="0"
            />
          </div>

          <!-- To'lov usuli -->
          <div class="field-group">
            <label class="flabel">To'lov usuli</label>
            <div class="pay-type-grid">
              <button
                v-for="pt in payTypes"
                :key="pt.id"
                class="pay-type-btn"
                :class="{ active: payModal.pay_type_id === pt.id }"
                @click="payModal.pay_type_id = pt.id"
              >{{ pt.name }}</button>
            </div>
          </div>

          <!-- Izoh -->
          <div class="field-group">
            <label class="flabel">Izoh (ixtiyoriy)</label>
            <input v-model="payModal.comment" type="text" class="finput" placeholder="Masalan: Noyabr oylik..." />
          </div>
        </div>
        <div class="modal-foot">
          <button class="btn-cancel-m" @click="payModal.show = false">Bekor</button>
          <button class="btn-pay-m" @click="submitPay" :disabled="payModal.loading">
            {{ payModal.loading ? 'Saqlanmoqda...' : 'To\'lash' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ MODAL: USTA MIJOZLARI ═══════════════ -->
    <div v-if="clientsModal.show" class="overlay" @click.self="clientsModal.show = false">
      <div class="modal-box history-modal-box">
        <div class="modal-head">
          <h3 class="modal-title">{{ clientsModal.name }} — Mijozlari</h3>
          <div style="display:flex; align-items:center; gap:10px;">
            <label class="show-all-toggle">
              <input type="checkbox" :checked="clientsModal.showAll" @change="toggleShowAll">
              Barcha tarix
            </label>
            <button class="close-btn" @click="clientsModal.show = false">&times;</button>
          </div>
        </div>
        <div v-if="!clientsModal.showAll && clientsModal.lastReset" class="reset-notice">
          {{ fmtDate(clientsModal.lastReset * 1000) }} dan keyingi savdolar ko'rsatilmoqda.
          <a href="#" @click.prevent="toggleShowAll">Barcha tarixni ko'rish</a>
        </div>
        <div class="modal-body" style="padding: 0;">
          <div v-if="clientsModal.loading" class="empty-row">Yuklanmoqda...</div>
          <div v-else-if="clientsModal.data.length === 0" class="empty-row">Mijoz yo'q</div>
          <table v-else class="ctable">
            <thead>
              <tr>
                <th class="th-left" style="padding-left:20px">MIJOZ</th>
                <th>TELEFON</th>
                <th>SAVDO SONI</th>
                <th>JAMI SUMMA</th>
                <th>ULUSH</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in clientsModal.data" :key="c.kontragent_id">
                <td class="td-left" style="padding-left:20px">
                  <div class="m-name">{{ c.client_name }}</div>
                </td>
                <td class="td-gray">{{ c.phone_number || '—' }}</td>
                <td class="td-dark td-bold">{{ c.sales_count }}</td>
                <td class="td-blue td-bold">{{ fmtM(c.total_summa) }}</td>
                <td class="td-green td-bold">{{ fmtM(clientShare(c)) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="summary-row">
                <td colspan="2" style="padding-left:20px"><b>JAMI</b></td>
                <td class="td-dark td-bold">{{ clientsModal.data.reduce((s, c) => s + Number(c.sales_count || 0), 0) }}</td>
                <td class="td-blue td-bold">{{ fmtM(clientsModal.data.reduce((s, c) => s + Number(c.total_summa || 0), 0)) }}</td>
                <td class="td-green td-bold">{{ fmtM(clientsModal.data.reduce((s, c) => s + clientShare(c), 0)) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <!-- ═══════════════ MODAL: OMMAVIY SOZLAMALAR ═══════════════ -->
    <div v-if="bulkModal.show" class="overlay" @click.self="bulkModal.show = false">
      <div class="modal-box bulk-modal-box">
        <div class="modal-head">
          <h3 class="modal-title">Ommaviy sozlamalar</h3>
          <button class="close-btn" @click="bulkModal.show = false">&times;</button>
        </div>
        <div class="modal-body">
          <div class="bulk-hint">
            Belgilangan maydonlar <b>barcha ustalarga</b> qo'llaniladi. Belgilanmagan maydonlar tegilmaydi.
          </div>

          <!-- Bonus % -->
          <div class="bulk-row" :class="{ active: bulkModal.useBonus }">
            <label class="bulk-check">
              <input type="checkbox" v-model="bulkModal.useBonus" />
              <span>Bonus %</span>
            </label>
            <input
              type="number"
              v-model.number="bulkModal.bonus"
              :disabled="!bulkModal.useBonus"
              min="0" max="100" step="0.1"
              class="finput"
              placeholder="masalan, 1"
            />
          </div>

          <!-- Ball summa -->
          <div class="bulk-row" :class="{ active: bulkModal.useBallSumma }">
            <label class="bulk-check">
              <input type="checkbox" v-model="bulkModal.useBallSumma" />
              <span>Ball uchun summa</span>
            </label>
            <input
              type="text"
              :value="bulkModal.ballSummaDisplay"
              @input="onBallSummaInput"
              :disabled="!bulkModal.useBallSumma"
              class="finput"
              placeholder="masalan, 100 000"
            />
          </div>

          <!-- Ball amount -->
          <div class="bulk-row" :class="{ active: bulkModal.useBallAmount }">
            <label class="bulk-check">
              <input type="checkbox" v-model="bulkModal.useBallAmount" />
              <span>Beriladigan ball</span>
            </label>
            <input
              type="number"
              v-model.number="bulkModal.ballAmount"
              :disabled="!bulkModal.useBallAmount"
              min="0" step="0.5"
              class="finput"
              placeholder="masalan, 1"
            />
          </div>

          <div v-if="bulkPreview" class="bulk-preview">
            <b>Natija:</b> har {{ bulkPreview.summa }} so'm uchun {{ bulkPreview.amount }} ball berildi
          </div>
        </div>
        <div class="modal-foot">
          <button class="btn-cancel-m" @click="bulkModal.show = false">Bekor</button>
          <button class="btn-save-m" @click="submitBulkUpdate" :disabled="bulkModal.loading || !bulkModal.useBonus && !bulkModal.useBallSumma && !bulkModal.useBallAmount">
            {{ bulkModal.loading ? 'Saqlanmoqda...' : 'Qo\'llash' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ MODAL 3: TARIX (saqlangan) ═══════════════ -->
    <div v-if="historyModal.show" class="overlay" @click.self="historyModal.show = false">
      <div class="modal-box history-modal-box">
        <div class="modal-head">
          <h3 class="modal-title">{{ historyModal.name }} — Operatsiyalar</h3>
          <button class="close-btn" @click="historyModal.show = false">&times;</button>
        </div>
        <div class="modal-body" style="padding:0;">
          <table class="ctable">
            <thead>
              <tr>
                <th class="th-left" style="padding-left:20px">Sana</th>
                <th>Sabab / Tur</th>
                <th>Summa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="historyModal.loading">
                <td colspan="3" class="empty-row">Yuklanmoqda...</td>
              </tr>
              <tr v-else-if="historyModal.data.length === 0">
                <td colspan="3" class="empty-row">Operatsiya yo'q</td>
              </tr>
              <tr v-for="item in historyModal.data" :key="item.id">
                <td class="td-left" style="padding-left:20px; font-size:12px;">{{ fmtDate(item.created_at) }}</td>
                <td>
                  <span class="type-tag" :class="item.type === 'chiqim' ? 'tag-red' : 'tag-green'">
                    {{ item.doc_type || item.type }}
                  </span>
                </td>
                <td :class="item.type === 'chiqim' ? 'td-red td-bold' : 'td-blue td-bold'">
                  {{ fmtM(item.summa) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';
import UstaForm from './Form.vue';

export default {
  components: { Top, UstaForm },

  data() {
    return {
      search: '',
      fetchLoading: false,
      masters: [],
      staffBalances: [],
      staffSummary: [],
      payTypes: [],
      ballReport: [],     // /staff/balance-report — ball_balance bilan

      payReasons: [
        // { value: 'Oylik',       label: 'Oylik',       icon: '📅' },
        { value: 'Kunlik',      label: 'Kunlik',       icon: '📆' },
        { value: 'Fiksa oylik', label: 'Fiksa',        icon: '📌' },
        { value: 'Bonus',       label: 'Bonus',        icon: '🎁' },
      ],

      // Form (create/edit)
      showForm: false,
      editItem: null,

      // Modal 2 — To'lov
      payModal: {
        show: false, loading: false,
        staffId: null, masterName: '', masterSalary: 0, masterBalance: 0,
        reason: 'Oylik',
        amount: 0, displayAmount: '',
        pay_type_id: null,
        comment: '',
      },

      // Modal 3 — Ustaning mijozlari
      clientsModal: {
        show: false, loading: false,
        staffId: null, name: '',
        data: [],
        showAll: false,
        lastReset: null,
      },
      // Legacy history modal (qolgan)
      historyModal: {
        show: false, loading: false,
        name: '', data: [],
      },

      // Ommaviy sozlamalar (bonus + ball)
      bulkModal: {
        show: false, loading: false,
        useBonus: true,        bonus: 1,
        useBallSumma: false,   ballSumma: 0,   ballSummaDisplay: '',
        useBallAmount: false,  ballAmount: 0,
      },
    };
  },

  computed: {
    allRows() {
      return this.masters.map(m => {
        const bal = this.staffBalances.find(b => b.id === m.id) || {};
        return {
          id:           m.id,
          name:         m.name,
          kirim_summa:  Number(bal.kirim_summa  || 0),
          chiqim_summa: Number(bal.chiqim_summa || 0),
        };
      });
    },

    filteredData() {
      if (!this.search) return this.allRows;
      const q = this.search.toLowerCase();
      return this.allRows.filter(r => r.name.toLowerCase().includes(q));
    },

    quickAmount() {
      const salary = Number(this.payModal.masterSalary || 0);
      if (!salary) return 0;
      if (this.payModal.reason === 'Kunlik') return Math.round(salary / 26);
      if (this.payModal.reason === 'Bonus') return 0;
      return salary;
    },

    bulkPreview() {
      const b = this.bulkModal;
      if (!b.useBallSumma && !b.useBallAmount) return null;
      const summa = b.useBallSumma ? this.fmtNumber(b.ballSumma) : '?';
      const amount = b.useBallAmount ? b.ballAmount : '?';
      return { summa, amount };
    },
  },

  mounted() { this.fetchData(); },

  methods: {
    // ── Data ──
    async fetchData() {
      this.fetchLoading = true;
      try {
        const [s, b, p, sum, br] = await Promise.all([
          axios.get('/api/v1/staff'),
          axios.get('/api/v1/staff_register'),
          axios.get('/api/v1/pay-type'),
          axios.get('/api/v1/staff/summary/clients'),
          axios.get('/api/v1/staff/balance-report'),
        ]);
        this.masters       = s.data.data   || [];
        this.staffBalances = b.data.data   || [];
        this.payTypes      = p.data        || [];
        this.staffSummary  = sum.data.data || [];
        this.ballReport    = br.data.items || [];
      } catch (e) { console.error(e); }
      finally { this.fetchLoading = false; }
    },

    getStaff(id) {
      return this.masters.find(m => m.id === id) || {};
    },
    getSummary(id) {
      return this.staffSummary.find(s => Number(s.staff_id) === Number(id)) || {};
    },
    getBallReport(id) {
      return this.ballReport.find(r => Number(r.staff_id) === Number(id)) || {};
    },
    ballEnabled(id) {
      const s = this.getStaff(id);
      return Number(s.ball_summa || 0) > 0 && Number(s.ball_amount || 0) > 0;
    },
    fmtNumber(v) {
      return Number(v || 0).toLocaleString('ru-RU').replace(/,/g, ' ');
    },
    computeShare(id) {
      // Joriy bonus% bo'yicha jami tushumdan ulush (nominal)
      const rev = Number(this.getSummary(id).total_revenue || 0);
      const pct = Number(this.getStaff(id).bonus || 0);
      return (rev * pct) / 100;
    },
    clientShare(c) {
      // Ustaning joriy bonus%i bo'yicha — mijoz tushumidan
      const pct = Number(this.getStaff(this.clientsModal.staffId).bonus || 0);
      return (Number(c.total_summa || 0) * pct) / 100;
    },

    openBulkUpdate() {
      // Modal default qiymatlar: bonusni yoqib, mavjud o'rtacha qiymat
      const avgBonus = this.masters.length
        ? Math.round(this.masters.reduce((s, m) => s + Number(m.bonus || 0), 0) / this.masters.length * 100) / 100
        : 1;
      Object.assign(this.bulkModal, {
        show: true, loading: false,
        useBonus: true,       bonus: avgBonus || 1,
        useBallSumma: false,  ballSumma: 0,  ballSummaDisplay: '',
        useBallAmount: false, ballAmount: 0,
      });
    },

    onBallSummaInput(e) {
      const raw = String(e.target.value || '').replace(/\D/g, '');
      this.bulkModal.ballSumma = Number(raw);
      this.bulkModal.ballSummaDisplay = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    async submitBulkUpdate() {
      const b = this.bulkModal;
      const payload = {};
      if (b.useBonus) {
        if (isNaN(b.bonus) || b.bonus < 0 || b.bonus > 100) return alert("bonus 0-100 oralig'ida bo'lishi kerak");
        payload.bonus = Number(b.bonus);
      }
      if (b.useBallSumma) {
        if (isNaN(b.ballSumma) || b.ballSumma < 0) return alert("ball_summa noto'g'ri");
        payload.ball_summa = Number(b.ballSumma);
      }
      if (b.useBallAmount) {
        if (isNaN(b.ballAmount) || b.ballAmount < 0) return alert("ball_amount noto'g'ri");
        payload.ball_amount = Number(b.ballAmount);
      }
      if (!Object.keys(payload).length) return alert('Kamida bitta maydonni belgilang');

      b.loading = true;
      try {
        const res = await axios.patch('/api/v1/staff/bulk-bonus', payload);
        b.show = false;
        const fields = Object.keys(res.data.applied || payload).join(', ');
        alert(`${res.data.updated} ta usta yangilandi (${fields})`);
        this.fetchData();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      } finally {
        b.loading = false;
      }
    },

    async resetAllBalances() {
      if (!confirm("Barcha ustalar PUL balansini 0 ga tushirasizmi? (Kassaga ta'sir qilmaydi)")) return;
      const cmt = prompt("Izoh:", "Aksiya tugadi");
      if (cmt === null) return;
      try {
        const res = await axios.post('/api/v1/staff/reset-balances', { comment: cmt });
        alert(`${res.data.reset_count} ta usta pul balansi 0 qilindi`);
        this.fetchData();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      }
    },

    async resetAllBallBalances() {
      if (!confirm("Barcha ustalarning BALL balansini 0 ga tushirasizmi? (Aksiya tugadi — pulga tegmaydi)")) return;
      const cmt = prompt("Izoh:", "Aksiya tugadi");
      if (cmt === null) return;
      try {
        const res = await axios.post('/api/v1/staff/reset-ball-balances', { comment: cmt });
        alert(`${res.data.reset_count} ta usta ball balansi 0 qilindi`);
        this.fetchData();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      }
    },

    async openClients(id, name) {
      this.clientsModal = { show: true, loading: true, staffId: id, name, data: [], showAll: false, lastReset: null };
      await this.loadClients();
    },
    async loadClients() {
      this.clientsModal.loading = true;
      try {
        const url = `/api/v1/staff/${this.clientsModal.staffId}/clients${this.clientsModal.showAll ? '?all=1' : ''}`;
        const res = await axios.get(url);
        this.clientsModal.data = res.data.data || [];
        this.clientsModal.lastReset = res.data.last_reset_at || null;
      } catch (e) { console.error(e); }
      finally { this.clientsModal.loading = false; }
    },
    toggleShowAll() {
      this.clientsModal.showAll = !this.clientsModal.showAll;
      this.loadClients();
    },

    // ── Form open ──
    openUstaModal(id = null) {
      if (id) {
        const s = this.masters.find(m => m.id === id);
        this.editItem = s ? { ...s } : null;
      } else {
        this.editItem = null;
      }
      this.showForm = true;
    },

    async deleteMaster(id) {
      const s = this.masters.find(m => m.id === id);
      if (!confirm(`"${s?.name}" o'chirilsinmi?`)) return;
      try {
        await axios.delete(`/api/v1/staff/${id}`);
        this.fetchData();
      } catch (e) {
        alert("O'chirishda xatolik: " + (e.response?.data?.message || e.message));
      }
    },

    // ── To'lov Modal ──
    async openPayModal(row) {
      const s = this.masters.find(m => m.id === row.id) || {};
      // Balansni olish
      let balance = row.kirim_summa - row.chiqim_summa;
      Object.assign(this.payModal, {
        show: true, loading: false,
        staffId: row.id, masterName: row.name,
        masterSalary: Number(s.salary || 0),
        masterBalance: balance,
        reason: 'Bonus',
        amount: 0, displayAmount: '',
        pay_type_id: this.payTypes.length ? this.payTypes[0].id : null,
        comment: '',
      });
    },

    selectReason(val) {
      this.payModal.reason = val;
      this.payModal.amount = 0;
      this.payModal.displayAmount = '';
    },

    fillQuick() {
      const amt = this.quickAmount;
      this.payModal.amount = amt;
      this.payModal.displayAmount = String(amt).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    handleAmount(e) {
      const raw = e.target.value.replace(/\D/g, '');
      this.payModal.amount = Number(raw);
      this.payModal.displayAmount = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    async submitPay() {
      if (!this.payModal.amount)      return alert('Summani kiriting!');
      if (!this.payModal.pay_type_id) return alert("To'lov usulini tanlang!");
      this.payModal.loading = true;
      try {
        await axios.post('/api/v1/user_pay', {
          staff_id:    this.payModal.staffId,
          summa:       this.payModal.amount,
          pay_type_id: this.payModal.pay_type_id,
          datetime:    Math.floor(Date.now() / 1000),
          sklad_id:    Number(localStorage.getItem('sklad_id')),
          reason:      this.payModal.reason,
          comment:     this.payModal.comment || `${this.payModal.masterName} — ${this.payModal.reason}`,
        });
        this.payModal.show = false;
        this.fetchData();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      } finally { this.payModal.loading = false; }
    },

    // ── Tarix Modal ──
    async openHistory(id, name) {
      this.historyModal = { show: true, loading: true, name, data: [] };
      try {
        const res = await axios.get(`/api/v1/staff_register/staff/${id}`);
        this.historyModal.data = res.data.data || [];
      } catch (e) { console.error(e); }
      finally { this.historyModal.loading = false; }
    },

    // ── Helpers ──
    fmtM(v) {
      const n = Number(v || 0);
      return n.toLocaleString('ru-RU').replace(/,/g, ' ') + " so'm";
    },
    shortM(v) {
      const n = Number(v || 0);
      if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
      if (n >= 1_000)     return (n / 1_000).toFixed(0)     + 'K';
      return String(n);
    },
    fmtDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleString('ru-RU', {
        day: '2-digit', month: '2-digit', year: '2-digit',
        hour: '2-digit', minute: '2-digit',
      });
    },
  },
};
</script>

<style scoped>
/* ─── Page ─── */
.g-page {
  padding: 28px 32px;
  background: #f8fafc;
  min-height: 100vh;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ─── Header ─── */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page-title {
  font-size: 28px;
  font-weight: 900;
  color: #5850ec;
  margin: 0;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.s-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}
.search-input {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 9px 14px 9px 36px;
  font-size: 13px;
  width: 220px;
  outline: none;
  transition: 0.2s;
}
.search-input:focus { border-color: #5850ec; box-shadow: 0 0 0 3px rgba(88,80,236,0.12); }
.btn-add-header {
  display: flex;
  align-items: center;
  gap: 7px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(88,80,236,0.3);
  transition: 0.2s;
}
.btn-add-header:hover { opacity: 0.9; }
.btn-bulk {
  background: #fef3c7;
  color: #92400e;
  border: 1.5px solid #fbbf24;
  height: 40px;
  padding: 0 14px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: .15s;
}
.btn-bulk:hover { background: #fbbf24; color: white; }
.btn-bulk.danger { background: #fff1f2; color: #e11d48; border-color: #fda4af; }
.btn-bulk.danger:hover { background: #e11d48; color: white; }
.btn-bulk.warning { background: #fffbeb; color: #b45309; border-color: #f59e0b; }
.btn-bulk.warning:hover { background: #f59e0b; color: white; }

/* ─── Bulk modal ─── */
.bulk-modal-box { width: 520px; }
.bulk-hint {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #1e40af;
  border-radius: 12px;
  padding: 10px 14px;
  font-size: 12.5px;
  line-height: 1.5;
}
.bulk-row {
  display: grid;
  grid-template-columns: 200px 1fr;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  transition: 0.2s;
}
.bulk-row.active {
  background: white;
  border-color: #5850ec;
  box-shadow: 0 0 0 3px rgba(88,80,236,0.08);
}
.bulk-check {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13.5px;
  font-weight: 700;
  color: #1e293b;
  cursor: pointer;
  user-select: none;
}
.bulk-check input[type=checkbox] {
  width: 18px; height: 18px;
  accent-color: #5850ec;
  cursor: pointer;
}
.bulk-row .finput:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}
.bulk-preview {
  margin-top: 4px;
  padding: 10px 14px;
  background: #f0fdf4;
  border: 1px solid #86efac;
  color: #166534;
  border-radius: 10px;
  font-size: 12.5px;
}

/* ─── Mobile responsive ─── */
@media (max-width: 768px) {
  .g-page { padding: 16px 12px; gap: 12px; }
  .header-row { flex-direction: column; align-items: stretch; gap: 12px; }
  .page-title { font-size: 22px; }
  .header-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .search-wrap { grid-column: 1 / -1; }
  .search-input { width: 100%; }
  .btn-bulk, .btn-add-header { width: 100%; padding: 0 10px; font-size: 12px; }
  .btn-add-header { grid-column: 1 / -1; }

  .modal-box,
  .pay-modal-box,
  .history-modal-box,
  .bulk-modal-box {
    width: calc(100vw - 24px);
    max-width: 520px;
    border-radius: 18px;
  }
  .bulk-row {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 12px;
  }
  .ctable { table-layout: auto; }
  .ctable thead th,
  .ctable tbody td { padding: 10px 8px; font-size: 12px; }
  .act-btn { width: 28px; height: 28px; }
}

/* ─── Table card ─── */
.table-card {
  background: white;
  border-radius: 20px;
  border: 1px solid #e8edf3;
  box-shadow: 0 4px 24px rgba(0,0,0,0.04);
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.table-wrap {
  overflow-y: auto;
  flex: 1;
}
.ctable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}
.ctable thead th {
  background: #f8fafc;
  border-bottom: 1.5px solid #e8edf3;
  padding: 14px 12px;
  font-size: 10px;
  font-weight: 800;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 5;
}
.th-left { text-align: left !important; padding-left: 20px !important; }
.ctable tbody td {
  padding: 13px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.td-left { text-align: left !important; padding-left: 20px !important; }
.td-blue  { color: #2563eb; }
.td-red   { color: #e11d48; }
.td-gray  { color: #64748b; }
.td-dark  { color: #1e293b; }
.td-green { color: #16a34a; }
.summary-row td { background: #f1f5f9 !important; border-top: 2px solid #5850ec; padding: 14px 12px !important; font-size: 14px; }
.show-all-toggle { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #475569; font-weight: 600; cursor: pointer; user-select: none; }
.show-all-toggle input { cursor: pointer; }
.reset-notice { padding: 10px 24px; background: #fef3c7; color: #92400e; font-size: 12px; border-bottom: 1px solid #fbbf24; }
.reset-notice a { color: #5850ec; font-weight: 700; margin-left: 6px; }
.td-bold  { font-weight: 800; }
.empty-row { text-align: center; padding: 40px; color: #94a3b8; font-weight: 600; }

.m-name { font-weight: 700; color: #1e293b; font-size: 14px; }
.m-phone { font-size: 11px; color: #94a3b8; margin-top: 1px; }

.trow { cursor: pointer; transition: background 0.15s; }
.trow:hover { background: #f8fafc; }

/* Action buttons */
.act-btns { display: flex; gap: 6px; justify-content: center; }
.act-btn {
  width: 32px; height: 32px;
  border: none; border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: 0.15s;
}
.act-btn.view { background: #f0fdf4; color: #16a34a; }
.act-btn.pay  { background: #eff6ff; color: #2563eb; }
.act-btn.edit { background: #f5f3ff; color: #5850ec; }
.act-btn.del  { background: #fff1f2; color: #e11d48; }
.act-btn:hover { filter: brightness(0.92); transform: scale(1.07); }

/* ─── Overlay ─── */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}

/* ─── Modal box ─── */
.modal-box {
  background: white;
  border-radius: 24px;
  width: 460px;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}
.pay-modal-box { width: 520px; }
.history-modal-box { width: 640px; max-height: 80vh; }

.modal-head {
  padding: 22px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.close-btn {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
  display: flex; align-items: center; justify-content: center;
}

.modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.modal-foot {
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  gap: 10px;
}

/* ─── Form fields ─── */
.field-group { display: flex; flex-direction: column; gap: 6px; }
.flabel { font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.3px; }
.finput {
  height: 44px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  outline: none;
  transition: 0.2s;
  width: 100%;
  box-sizing: border-box;
}
.finput:focus { border-color: #5850ec; box-shadow: 0 0 0 3px rgba(88,80,236,0.1); }
.finput-lg { height: 52px; font-size: 18px; font-weight: 800; }
.field-row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

/* Foot buttons */
.btn-cancel-m {
  flex: 1; height: 46px;
  background: #f1f5f9; color: #64748b;
  border: none; border-radius: 14px;
  font-weight: 700; cursor: pointer;
}
.btn-save-m {
  flex: 2; height: 46px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none; border-radius: 14px;
  font-weight: 800; cursor: pointer;
  transition: 0.2s;
}
.btn-save-m:disabled { opacity: 0.6; }
.btn-pay-m {
  flex: 2; height: 46px;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: white; border: none; border-radius: 14px;
  font-weight: 800; cursor: pointer;
}
.btn-pay-m:disabled { opacity: 0.6; }

/* ─── Pay modal internals ─── */
.master-badge {
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
  border: 1px solid #bae6fd;
  border-radius: 14px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
}
.master-avatar {
  width: 44px; height: 44px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border-radius: 50%;
  font-size: 20px; font-weight: 900;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.master-badge-name { font-size: 16px; font-weight: 800; color: #1e293b; }
.master-badge-info { font-size: 12px; color: #64748b; margin-top: 3px; }
.c-red { color: #e11d48; }
.c-green { color: #16a34a; }

/* Reason grid */
.reason-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.reason-btn {
  height: 56px;
  border: 1.5px solid #e2e8f0;
  background: white;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  color: #475569;
  transition: 0.15s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
}
.reason-btn .r-icon { font-size: 18px; }
.reason-btn:hover { border-color: #5850ec; color: #5850ec; }
.reason-btn.active { background: #5850ec; border-color: #5850ec; color: white; }

/* Amount label row */
.label-row { display: flex; justify-content: space-between; align-items: center; }
.quick-btn {
  background: #ede9fe;
  border: 1.5px solid #a78bfa;
  border-radius: 8px;
  color: #5850ec;
  font-size: 12px; font-weight: 800;
  padding: 3px 10px; cursor: pointer;
  transition: 0.15s;
}
.quick-btn:hover { background: #5850ec; color: white; border-color: #5850ec; }

/* Pay type grid */
.pay-type-grid {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.pay-type-btn {
  flex: 1;
  min-width: 80px;
  height: 40px;
  border: 1.5px solid #e2e8f0;
  background: white;
  border-radius: 10px;
  font-size: 13px; font-weight: 700;
  cursor: pointer; color: #475569;
  transition: 0.15s;
}
.pay-type-btn:hover { border-color: #22c55e; color: #16a34a; }
.pay-type-btn.active { background: #22c55e; border-color: #22c55e; color: white; }

/* History modal */
.type-tag {
  font-size: 11px; font-weight: 800;
  padding: 3px 8px; border-radius: 6px;
  text-transform: uppercase;
}
.tag-red   { background: #fff1f2; color: #e11d48; }
.tag-green { background: #f0fdf4; color: #16a34a; }
</style>
